/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Unmatched_HintInputs */

const cs_demands_unmatched_hint = /** @type {(inputs: Demands_Unmatched_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spusťte párování, aby se našly vyhovující nemovitosti.`)
};

const en_demands_unmatched_hint = /** @type {(inputs: Demands_Unmatched_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run matching to find suitable listings.`)
};

/**
* | output |
* | --- |
* | "Run matching to find suitable listings." |
*
* @param {Demands_Unmatched_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_unmatched_hint = /** @type {((inputs?: Demands_Unmatched_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Unmatched_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_unmatched_hint(inputs)
	return cs_demands_unmatched_hint(inputs)
});